// extracted by mini-css-extract-plugin
export var box = "_51-1";
export var checkboxRow = "_51-8";
export var checked = "_51-2";
export var descriptionSpacer = "_51-a";
export var disabled = "_51-3";
export var icon = "_51-6";
export var input = "_51-0";
export var labelSpacer = "_51-9";
export var medium = "_51-5";
export var small = "_51-4";
export var text = "_51-7";